import React from 'react';
import './custom-button.scss';

const CustomButton = ({onClick, value, title, icon, customStyle, disabled}) => {
    return <button 
        className={`custom-button ${ customStyle }`} 
        onClick={ onClick } 
        value={ value }
        disabled={ disabled }
    >
        <label  className={ `custom-label ${ customStyle!==undefined?"primary-label": "" }` }><i className={ icon }/>&nbsp;&nbsp;{title}</label>
     </button>
}

export default CustomButton;